import React, { useEffect, useState } from "react";
import { useNotificationContext } from "../../../common/NotificationContext";
import { useLoading } from "../../../common/LoadingContext";
import {
  departmentsListingSearchService,
  departmentsListingService,
} from "../../../services/UserOnboardingService";
import DepartmentsList from "./DepartmentsList";
import useGlobalState from "../../../Context";

const Depaertment = () => {
  const [totalElements, setTotalElements] = useState(0);
  // const [tableLoader, setTableLoader] = useState(false);
  const { showNotification } = useNotificationContext();
  const { setLoading } = useLoading();
  const [departmentsList, setDepartmentList] = useState([]);
  const [noRecord, setNoRecord] = useState(false);
  // const auth = JSON.parse(localStorage.getItem("SPMS_INTERNAL_STATE"));
  const [{ auth }, dispatch] = useGlobalState();
  const loginUserType = auth.ldapParam.userType;

  useEffect(() => {
    fetchDepartmentsList("name", false);
  }, []);

  const fetchDepartmentsList = async (sortBy, isAsc,searchValue,paginationData) => {
    try {
      setLoading(true);
    const requestBody = {
       pageNumber: paginationData?.page ?? 0,
       pageSize:  paginationData?.pageSize ??  10,
       filterSearch:searchValue ? searchValue : null,
       active: 2,
       sortBy: sortBy,
       sortDirection: isAsc ? "DESC" : "ASC",
      };
      const departmentsListingResponse = await departmentsListingService(requestBody);
      if (departmentsListingResponse.statusCode === 6) {
        if (departmentsListingResponse.data.content?.length === 0) {
          setNoRecord(true);
        } else {
          setNoRecord(false);
        }
        setDepartmentList(departmentsListingResponse.data.content);
        setTotalElements(departmentsListingResponse.data.totalElements);
      } else {
        showNotification("Error", departmentsListingResponse.message, "error");
      }
    } catch (err) {
      console.log("error", err);
      showNotification("Error", "fail to fetch Departments listing", "error");
    } finally {
      setLoading(false);
    }
  };
 
  const onSearch = async (values, searchValue) => {
    try {
      setLoading(true);
      const requestBody = {
        pageNumber: values?.pageNumber ?? 0,
        pageSize: values?.pageSize ?? 10,
        sortBy: values?.orderBy ?? "name",
        sortDirection: "ASC",
        active: loginUserType === "Main Admin" ? 2 : 0,
      };
      const departmentsListingResponse = await departmentsListingSearchService(
        requestBody,
        searchValue
      );

      if (departmentsListingResponse.statusCode === 6) {
        if (departmentsListingResponse.data.content?.length === 0) {
          setNoRecord(true);
        } else {
          setNoRecord(false);
        }
        setDepartmentList(departmentsListingResponse.data.content);
        setTotalElements(departmentsListingResponse.data.totalElements);
      } else {
        showNotification("Error", departmentsListingResponse.message, "error");
      }
    } catch (err) {
      showNotification("Error", err.message ?? "Failed to fetch user details");
    } finally {
      setLoading(false);
    }
  };

  const handleTableChanges = async (
    paginationValues,
    isUpdate,
    sortValue,
    orderBy,searchValue
  ) => {
    try {
      setLoading(true);
      const requestBody = {
        pageNumber: paginationValues?.pageNumber ?? 0,
        pageSize: paginationValues?.pageSize ?? 10,
        active: 2,
        filterSearch: searchValue ? searchValue.trim() : null,
        sortBy: orderBy,
        sortDirection: sortValue === null ? "DESC" : sortValue,
      };
      // setTableLoader(true);
      const response = await departmentsListingService(requestBody);

      if (response.statusCode === 6) {
        if (isUpdate) {
          setDepartmentList([...departmentsList, ...response.data.content]);
        } else {
          setDepartmentList(response.data.content);
        }
      } else {
        showNotification("Error", response.message, "error");
      }
    } catch (e) {
      showNotification("Error", "Failed to fetch Departments list data");
    } finally {
      setLoading(false);
      // setTableLoader(false);
    }
  };

  return (
    <DepartmentsList
      totalElements={totalElements}
      setDepartmentList={setDepartmentList}
      onSearch={onSearch}
      handleTableChanges={handleTableChanges}
      setLoading={setLoading}
      showNotification={showNotification}
      fetchDepartmentsList={fetchDepartmentsList}
      departmentsList={departmentsList}
      noRecord={noRecord}
    
    />
  );
};

export default Depaertment;
